import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b023e95")

_pushScopeId("data-v-4b023e95")
const _hoisted_1 = { class: "hero is-fullheight-with-navbar" }
const _hoisted_2 = { class: "hero head is-flex is-justify-content-space-around mx-3" }
const _hoisted_3 = { class: "has-text-centered is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: "https://lh3.googleusercontent.com/d/1c26r3BgWhhwudclznZJ_h9IJO6pyUHMo",
  class: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" CODE MENTORING & CTFs are the best way to learn Hacking and Cyber Security. ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "has-text-weight-normal" }, " Cohackers help you improve your hacking skills and find like-minded teammates. ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "is-flex is-flex-direction-column is-align-items-center my-6" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" All our Mentors have professionals experiences and well-known certifications. ")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Match with a hacking coach and ")
const _hoisted_16 = /*#__PURE__*/_createVNode("b", null, " begin your learning adventure.", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Talking with mentors will make you progress in a blink. You will learn faster by following their learning program and apply their advice ")
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("b", null, " LEARN with a mentor - PRACTICE with CTFs - PROGRESS - REPEAT ", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Interested? ")
const _hoisted_28 = { class: "mb-6" }
const _hoisted_29 = { class: "columns is-multiline mr-0 has-margin-top" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "column is-7-desktop is-flex is-flex-direction-column is-align-items-center is-justify-content-center pr-0" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "build-image",
    src: "/img/home/Build.svg"
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "hands-image",
    src: "/img/home/main_final.png"
  })
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Surround yourself with talented hackers. ")
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" You'll progress in groups, learn new skills,discover new challenges. ")
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Acquire more experiences with your teammates by playing CTFs together & start earning bounties! ")
const _hoisted_38 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_39 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" JOIN THE ADVENTURE ")
const _hoisted_41 = { class: "hero mt-6" }
const _hoisted_42 = {
  key: 0,
  class: "is-flex div-cards overflow-auto"
}
const _hoisted_43 = {
  align: "middle",
  class: "has-margin-bottom-and-top"
}
const _hoisted_44 = {
  class: "hero",
  style: {"margin-top":"3%"}
}
const _hoisted_45 = { class: " " }
const _hoisted_46 = {
  class: "columns is-multiline",
  style: {"margin-right":"0"}
}
const _hoisted_47 = {
  class: "column is-7-desktop ",
  style: {"background-color":"black"}
}
const _hoisted_48 = {
  class: "jointheteam has-text-centered",
  style: {"margin-left":"7%"}
}
const _hoisted_49 = {
  style: {"color":"white","margin-top":"2%"},
  align: "left"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Every month, we'll send you tips to help you learn hacking, testing, and news about the latest cyber attacks. ")
const _hoisted_53 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Also, you will be the first to know about new CTFs on the list. ")
const _hoisted_56 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_58 = {
  class: "column is-5-desktop",
  style: {"color":"white","display":"flex","flex-direction":"column","align-items":"start","justify-content":"center"}
}
const _hoisted_59 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = { style: {"display":"flex"} }
const _hoisted_62 = /*#__PURE__*/_createVNode("img", {
  style: {"margin":"5% 0","width":"15%","border":"0.01px solid grey","border-left":"none"},
  src: "/img/home/Icon_enter.svg"
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("p", { style: { display: 'flex', alignItems: 'start' } }, " We won't send you spam, we promise ... ", -1)
const _hoisted_64 = {
  class: "hero-body",
  style: {"margin-top":"5%"}
}
const _hoisted_65 = { class: "container has-text-centered" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" @Cohackers 2021 ")
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" GTC ")
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" All rights reserved ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ctf_card = _resolveComponent("ctf-card")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("b", {
          class: "subtitle has-text-white has-text-weight-bold",
          style: {
            fontSize:
              _ctx.windowWidth <= 768
                ? '22px'
                : _ctx.windowWidth <= 1215
                ? '30px'
                : '35px'
          }
        }, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ], 4),
        _hoisted_9
      ])
    ]),
    _createVNode("section", _hoisted_10, [
      _createVNode("img", {
        src: 
          _ctx.windowWidth <= 768
            ? _ctx.MENTORING_MOBILE_IMAGE_URL
            : _ctx.MENTORING_DESKTOP_IMAGE_URL
        ,
        alt: "mentoring",
        style: { width: _ctx.windowWidth <= 768 ? '95%' : '65%' }
      }, null, 12, ["src"]),
      _createVNode("p", {
        class: "has-text-centered",
        style: {
          fontSize:
            _ctx.windowWidth <= 950 ? '18px' : _ctx.windowWidth <= 1215 ? '25px' : '30px'
        }
      }, [
        _createVNode("b", {
          style: {
            fontSize:
              _ctx.windowWidth <= 950
                ? '20px'
                : _ctx.windowWidth <= 1215
                ? '25px'
                : '30px'
          }
        }, " MENTORING IS KEY! ", 4),
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _hoisted_18,
        _createVNode("b", {
          style: {
            fontSize:
              _ctx.windowWidth <= 950
                ? '20px'
                : _ctx.windowWidth <= 1215
                ? '25px'
                : '30px'
          }
        }, " WHY MENTORING? ", 4),
        _hoisted_19,
        _hoisted_20,
        _hoisted_21,
        _hoisted_22,
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _hoisted_26,
        _hoisted_27
      ], 4),
      _createVNode("button", {
        class: "is-flex is-justify-content-center is-align-items-center has-text-weight-bold start-now-button",
        style: {
          padding: _ctx.windowWidth <= 768 ? '3px' : '45px',
          height: _ctx.windowWidth <= 768 ? '50px' : '60px',
          fontSize:
            _ctx.windowWidth <= 768 ? '110%' : _ctx.windowWidth <= 1200 ? '135%' : '180%'
        },
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
      }, " JOIN THE ADVENTURE ", 4)
    ]),
    _createVNode("section", _hoisted_28, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("div", {
            class: "column is-5-desktop pl-0",
            style: {
              paddingRight: _ctx.windowWidth <= 1410 ? '5%' : '3%',
              paddingTop: _ctx.windowWidth <= 1410 ? '0' : '4%'
            }
          }, [
            _createVNode("p", {
              class: "has-text-weight-bold has-text-right has-color",
              style: {
                fontSize:
                  _ctx.windowWidth <= 768
                    ? '30px'
                    : _ctx.windowWidth <= 1410
                    ? '25px'
                    : '40px'
              }
            }, " FIND LIKE-MINDED TEAMMATES TO JOIN THE ADVENTURE ", 4),
            _hoisted_31,
            _createVNode("p", {
              class: "has-text-right has-text-white  ",
              style: {
                fontSize:
                  _ctx.windowWidth <= 950
                    ? '18px'
                    : _ctx.windowWidth <= 1215
                    ? '25px'
                    : '30px'
              }
            }, [
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37
            ], 4),
            _hoisted_38,
            _createVNode("div", _hoisted_39, [
              _createVNode("button", {
                class: "is-flex is-align-items-center is-justify-content-center has-text-weight-bold start-now-button",
                style: {
                  height: _ctx.windowWidth <= 768 ? '50px' : '60px',
                  fontSize:
                    _ctx.windowWidth <= 352
                      ? '15px'
                      : _ctx.windowWidth <= 807
                      ? '20px'
                      : _ctx.windowWidth <= 1247
                      ? '22px'
                      : _ctx.windowWidth <= 1275
                      ? '24px'
                      : '30px'
                },
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
              }, [
                _hoisted_40,
                _createVNode("img", {
                  class: "ml-4",
                  style: {
                    width:
                      _ctx.windowWidth <= 500
                        ? '6vw'
                        : _ctx.windowWidth <= 768
                        ? '5vw'
                        : '3vw'
                  },
                  src: "/img/home/Arrow_in_button.svg"
                }, null, 4)
              ], 4)
            ])
          ], 4)
        ])
      ])
    ]),
    _createVNode("section", _hoisted_41, [
      _createVNode("img", {
        src: 
          _ctx.windowWidth <= 768 ? _ctx.DISCOVER_MOBILE_IMAGE : _ctx.DISCOVER_DESKTOP_IMAGE
        ,
        style: { width: _ctx.windowWidth <= 768 ? '75%' : '100%' }
      }, null, 12, ["src"]),
      _createVNode("div", {
        style: { marginLeft: _ctx.windowWidth <= 535 ? 0 : '20%' }
      }, [
        (_ctx.ctfCards && _ctx.ctfCards.findCtf)
          ? (_openBlock(), _createBlock("div", _hoisted_42, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ctfCards.findCtf, ({ id, image, title, members, url }) => {
                return (_openBlock(), _createBlock("div", {
                  key: id,
                  class: " column is-12-mobile is-6-tablet is-4-widescreen is-3-fullhd"
                }, [
                  _createVNode(_component_ctf_card, {
                    id: id,
                    image: image,
                    title: title,
                    members: members,
                    url: 
                url.length > 26
                  ? `${url.substr(0, 15)}...${url.substr(url.length - 8)}`
                  : url
              ,
                    "data-testid": "ctf-card"
                  }, null, 8, ["id", "image", "title", "members", "url"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 4),
      _createVNode("div", _hoisted_43, [
        _createVNode("p", {
          class: "has-text-weight-normal title has-text-white",
          style: {
            fontSize:
              _ctx.windowWidth <= 950
                ? '18px'
                : _ctx.windowWidth <= 1215
                ? '25px'
                : '30px'
          }
        }, " Find new challenging CTFs. ", 4),
        _createVNode("button", {
          class: "discover-button",
          style: {
            height: _ctx.windowWidth <= 768 ? '50px' : '60px',
            fontSize:
              _ctx.windowWidth <= 768
                ? '110%'
                : _ctx.windowWidth <= 1200
                ? '135%'
                : '180%'
          },
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
        }, " DISCOVER ", 4)
      ])
    ]),
    _createVNode("section", _hoisted_44, [
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _createVNode("p", {
                  style: {
                    paddingTop: '10%',
                    fontSize:
                      _ctx.windowWidth <= 950
                        ? '18px'
                        : _ctx.windowWidth <= 1215
                        ? '25px'
                        : '30px'
                  }
                }, [
                  _hoisted_50,
                  _hoisted_51,
                  _hoisted_52,
                  _hoisted_53,
                  _hoisted_54,
                  _hoisted_55,
                  _hoisted_56,
                  _hoisted_57
                ], 4)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_58, [
            _createVNode("div", {
              style: {
                marginLeft: '5%',
                marginTop: _ctx.windowWidth <= 600 ? '-18%' : '-5%'
              }
            }, [
              _hoisted_59,
              _hoisted_60,
              _createVNode("p", {
                style: {
                  display: 'flex',
                  alignItems: 'start',
                  fontSize:
                    _ctx.windowWidth <= 768
                      ? '23px'
                      : _ctx.windowWidth <= 1215
                      ? '25px'
                      : '35px'
                }
              }, " What's your email address? ", 4),
              _createVNode("div", _hoisted_61, [
                _createVNode("input", {
                  style: {
                    width: '70%',
                    margin: '5% 0',
                    padding: '13px',
                    paddingRight: '0',
                    backgroundColor: 'black',
                    color: 'white',
                    border: '0.01px solid grey',
                    borderRight: 'none',
                    fontSize:
                      _ctx.windowWidth <= 600
                        ? '17px'
                        : _ctx.windowWidth <= 1023
                        ? '20px'
                        : _ctx.windowWidth <= 1215
                        ? '25px'
                        : '30px'
                  },
                  placeholder: "youremail@email.com"
                }, null, 4),
                _hoisted_62
              ]),
              _hoisted_63
            ], 4)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_64, [
      _createVNode("div", _hoisted_65, [
        _createVNode("h6", null, [
          _hoisted_66,
          _createVNode(_component_router_link, { to: "/?gtc=true" }, {
            default: _withId(() => [
              _hoisted_67
            ]),
            _: 1
          }),
          _hoisted_68
        ])
      ])
    ])
  ]))
})